import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Pipe({
  name: 'productImage'
})
export class ProductImagePipe implements PipeTransform {
  transform(value: string): any {
    return value
      ? value.includes('http://') || value.includes('https://')
        ? value
        : `${environment.appUrl}${value}`
      : `${environment.appUrl}/assets/icons/no-image-available-icon_75x75.svg`;
  }
}
